<template>
  <div class="dealers-page">
    <section class="page-heading page-heading--compact">
      <div class="content-width">
        <p class="eyebrow">{{ pageTitle }}</p>
        <h1>{{ pageTitle }}</h1>
      </div>
    </section>
    <section class="dealers-layout content-width">
      <div class="dealers-sidebar">
        <div class="dealer-filters">
          <div class="filter-row">
            <label class="country-filter-label filter-select-label" for="country-filter">
              <span>{{ selectedCountryLabel }}</span>
              <span class="filter-chevron" aria-hidden="true"></span>
              <select id="country-filter" v-model="country" class="filter-select-native">
                <option value="all">{{ $store.getters.t('all') }}</option>
                <option v-for="item in countries" :key="item" :value="item">{{ item }}</option>
              </select>
            </label>
            <label v-if="hasSelectedCountry" class="city-filter-label filter-select-label" for="dealer-city-filter">
              <span>{{ selectedCityLabel }}</span>
              <span class="filter-chevron" aria-hidden="true"></span>
              <select id="dealer-city-filter" v-model="city" class="filter-select-native">
                <option value="all">{{ $store.getters.t('all') }}</option>
                <option v-for="item in cities" :key="item" :value="item">{{ item }}</option>
              </select>
            </label>
          </div>
          <div class="field-with-icon">
            <span class="dealer-search-icon" aria-hidden="true"></span>
            <input id="dealer-filter" v-model.trim="keyword" type="search" :placeholder="$store.getters.t('addressPlaceholder')">
          </div>
        </div>
        <DealerList :dealers="filteredDealers" :loading="loading" :item-label-key="serviceMode ? 'serviceCenters' : 'stores'" />
        <div v-if="error" class="state-error-inline">{{ error }}</div>
      </div>
    </section>
    <FloatingHomeButton />
  </div>
</template>

<script>
import { getDealers, getServiceProviders, listData } from '../api/portal'
import DealerList from '../components/DealerList.vue'
import FloatingHomeButton from '../components/FloatingHomeButton.vue'

export default {
  name: 'DealersView',
  components: { DealerList, FloatingHomeButton },
  props: { serviceMode: { type: Boolean, default: false } },
  data () { return { dealers: [], keyword: '', city: '', country: '', loading: false, error: '' } },
  computed: {
    pageTitle () { return this.$store.getters.t(this.serviceMode ? 'serviceProviders' : 'dealers') },
    hasSelectedCountry () { return Boolean(this.country && this.country !== 'all') },
    cities () {
      if (!this.hasSelectedCountry) return []
      return Array.from(new Set(this.dealers
        .filter(dealer => String((dealer && dealer.country) || '').trim() === this.country)
        .map(dealer => dealer && dealer.city ? String(dealer.city).trim() : '')
        .filter(Boolean)))
        .sort((left, right) => left.localeCompare(right))
    },
    countries () {
      return Array.from(new Set(this.dealers.map(dealer => dealer && dealer.country ? String(dealer.country).trim() : '').filter(Boolean))).sort((left, right) => left.localeCompare(right))
    },
    selectedCityLabel () {
      return this.city && this.city !== 'all' ? this.city : this.$store.getters.t('chooseCity')
    },
    selectedCountryLabel () {
      return this.country && this.country !== 'all' ? this.country : this.$store.getters.t('chooseCountry')
    },
    filteredDealers () {
      const value = this.keyword.toLowerCase()
      const selectedCity = this.city && this.city !== 'all' ? this.city : ''
      const selectedCountry = this.country && this.country !== 'all' ? this.country : ''
      return this.dealers.filter(dealer => {
        const matchesCity = !selectedCity || String(dealer.city || '').trim() === selectedCity
        const matchesCountry = !selectedCountry || String(dealer.country || '').trim() === selectedCountry
        const matchesKeyword = !value || [dealer.city, dealer.country, dealer.address, dealer.phone, dealer.email].filter(Boolean).join(' ').toLowerCase().includes(value)
        return matchesCity && matchesCountry && matchesKeyword
      })
    }
  },
  created () {
    this.loadDealers()
  },
  watch: {
    country () { this.city = '' },
    serviceMode () {
      this.dealers = []
      this.keyword = ''
      this.city = ''
      this.country = ''
      this.loadDealers()
    }
  },
  methods: {
    async loadDealers () {
      this.loading = true
      this.error = ''
      try {
        const request = this.serviceMode ? getServiceProviders : getDealers
        this.dealers = listData(await request())
      } catch (error) {
        this.dealers = []
        this.error = error.message || this.$store.getters.t(this.serviceMode ? 'unableLoadServiceProviders' : 'unableLoadDealers')
      } finally { this.loading = false }
    }
  }
}
</script>
